const light = {
  background: '#fff',
  label: '#222831',
  url: '#393e46',
  boxColor: '#ececec',
  buttonColor: '#f7f7f7',
  borderColor: '#eeeeee',
  itemBorder: '#fff',
  voteColor: '#cac8c8',
  boxHoverColor: '#f7f7f7',
  deleteIcon: '#F73B5E',
  upVote: '#61C25E',
  downVote: '#F73B5E',
  linkHoverColor: '#f18902',
  inputBorderColor: '#222831',
  placeholderColor: '#afb1b3',
  ok: '#61C25E',
  cancel: '#F73B5E',
  hepsiburada: '#f18902',
};

const dark = {
  background: '#26242E',
  label: '#fff',
  url: '#808080',
  boxColor: '#2c2938',
  buttonColor: '#2d2938',
  borderColor: '#18161d',
  itemBorder: '#2d2938',
  voteColor: '#cac8c8',
  boxHoverColor: '#2d2938',
  deleteIcon: '#F73B5E',
  upVote: '#61C25E',
  downVote: '#F73B5E',
  linkHoverColor: '#f18902',
  inputBorderColor: '#afb1b3',
  ok: '#61C25E',
  cancel: '#F73B5E',
  hepsiburada: '#f18902',
};

const themes = {
  light,
  dark,
};

export default themes;
